 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import {Close, Search} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import React, {useRef} from 'react'
import {useFragment} from 'react-relay'
import { matchPath} from 'react-router'
import {commitLocalUpdate} from 'relay-runtime'

import useAtmosphere from '~/hooks/useAtmosphere'
import useRouter from '~/hooks/useRouter'
import {PALETTE} from '~/styles/paletteV3'


const getShowSearch = (location) => {
  const {pathname} = location
  return (
    pathname.includes('/me/tasks') ||
    !!matchPath(pathname, {
      path: '/team/:teamId',
      exact: true,
      strict: false
    }) ||
    !!matchPath(pathname, {
      path: '/team/:teamId/archive',
      exact: true,
      strict: false
    }) ||
    !!matchPath(pathname, {
      path: '/meetings',
      exact: true,
      strict: false
    })
  )
}




const Wrapper = styled('div')(({location}) => ({
  alignItems: 'center',
  backgroundColor: 'hsla(0,0%,100%,.125)',
  borderRadius: 4,
  display: 'flex',
  flex: 1,
  height: 40,
  margin: 8,
  maxWidth: 480,
  visibility: getShowSearch(location) ? undefined : 'hidden'
}))

const SearchInput = styled('input')({
  appearance: 'none',
  border: '1px solid transparent',
  color: PALETTE.SLATE_200,
  fontSize: 20,
  lineHeight: '24px',
  margin: 0,
  outline: 0,
  padding: '12px 16px',
  backgroundColor: 'transparent',
  width: '100%'
})

const SearchIcon = styled('div')({
  height: 24,
  width: 24,
  color: '#fff',
  cursor: 'pointer',
  margin: 12
})

const setSearch = (atmosphere, value) => {
  commitLocalUpdate(atmosphere, (store) => {
    const viewer = store.getRoot().getLinkedRecord('viewer')
    if (!viewer) return
    viewer.setValue(value, 'dashSearch')
  })
}

const TopBarSearch = (props) => {
  const {viewer: viewerRef} = props
  const viewer = useFragment(
    graphql`
      fragment TopBarSearch_viewer on User {
        dashSearch
      }
    `,
    viewerRef
  )
  const dashSearch = _nullishCoalesce(_optionalChain([viewer, 'optionalAccess', _ => _.dashSearch]), () => ( ''))
  const inputRef = useRef(null)
  const atmosphere = useAtmosphere()
  const {location} = useRouter()
  const onChange = (e) => {
    setSearch(atmosphere, e.target.value)
  }
  const Icon = dashSearch ? Close : Search
  const onClick = () => {
    setSearch(atmosphere, '')
    _optionalChain([inputRef, 'access', _2 => _2.current, 'optionalAccess', _3 => _3.focus, 'call', _4 => _4()])
  }
  return (
    React.createElement(Wrapper, { location: location,}
      , React.createElement(SearchInput, { ref: inputRef, onChange: onChange, placeholder: 'Search', value: dashSearch,} )
      , React.createElement(SearchIcon, { onClick: onClick,}
        , React.createElement(Icon, null )
      )
    )
  )
}

export default TopBarSearch
